import { formatCurrencyAmount } from "@/shared/utils/currencyMinorUnits";

import { currencySymbol } from "../../utils/currencyDisplay";

/** A figure with its symbol, at the currency's own precision and grouped for the reader: `R$ 1.012,50`. */
export const formatSendMoney = (
  value: string | null | undefined,
  currency: string,
  locale: string,
): string => {
  const symbol = currencySymbol(currency);
  const amount = formatCurrencyAmount(value, currency, locale);
  return symbol ? `${symbol} ${amount}` : amount;
};

/** The same figure with its code after it, for any line where two currencies sit together: `R$ 12,50 BRL`. */
export const formatSendMoneyWithCode = (
  value: string | null | undefined,
  currency: string,
  locale: string,
): string => `${formatSendMoney(value, currency, locale)} ${currency}`;
